<template>
  <img v-if="hasLogo" class="v-toolbar-logo" :src="logoUrl" />
  <div v-else class="v-toolbar__text">
    {{ fallbackText }}
  </div>
</template>

<script>
import { isPresent, getImageUrl } from "@/lib/utils"

export default {
  props: {
    logo: { type: Object, default: () => ({}) },
    fallbackText: { type: String, default: "" }
  },

  computed: {
    hasLogo() {
      return isPresent(this.logo)
    },

    logoUrl() {
      return getImageUrl(this.logo)
    }
  }
}
</script>

<style lang="scss">
.v-toolbar-logo {
  height: var(--mvt-logo-height, 50%);
}
</style>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.v-toolbar-logo {
  max-height: 100%;
  max-width: 208px;
  align-self: center;
  max-height: $toolbar--height;
  min-width: 0;
  flex-shrink: 1;
  object-fit: contain;
}
</style>
